<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style>

#app .main-container {
height:100%;
}

/*布局方式1.通用布局，标识btModel */
.app-container.btModel
{
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
}
/*无分页时布局*/
.app-container.btModel>.scroll-container
{
   position: absolute;
    top: 56px;
    bottom: 10px;
    left: 10px;
    right: 10px;
}

/*有分页时布局，标识isPagination*/
.app-container.btModel.isPagination>.scroll-container
{
   position: absolute;
    top: 56px;
    bottom: 52px;
    left: 10px;
    right: 10px;
}
.app-container.btModel.isPagination>.pagination-container {
    position: absolute;
    bottom: 10px;
    left:0;
    width:100%;
    margin-top: 10px;
    padding: 0px 16px !important;
}

/*布局方式2.tab页签时布局，标识tabModel */
.app-container.tabModel {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: grid;
    grid-template-rows:46px auto;
    grid-template-columns: 100%;
  }
/*有分页时布局，标识isPagination*/
.app-container.tabModel.isPagination {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: grid;
    grid-template-rows:46px auto 42px;
    grid-template-columns: 100%;
 }
.app-container.tabModel.isPagination >.pagination-container{
    margin-top: 10px;
    padding: 0px 16px !important;
 }

.fixed-header+.app-main
{
  height:100%;
}

.app-wrapper{
  overflow: hidden;
}
.pagination-container
{
  padding: 0px 16px !important;
  margin-top: 10px;
}
 .el-table .cell
    {
      white-space: nowrap !important;
    }
    .el-table th>.cell
    {
      padding-left: 5px;
      padding-right: 5px;
    }
    .el-table th>.cell>.el-tooltip>span{
       margin-left: 0px !important;
    }
    .filter-container{
      padding-bottom: 0px !important;
    }
   .el-table{
  font-size: 14px;
    font-family: "Microsoft YaHei","Verdana", "Tahoma", "Lucida Grande", "Hiragino Sans GB", sans-serif;
    color: #333;
    font-weight: normal;
        border: 1px solid #ccc !important;
}
    .el-table-column--selection .cell
    {
      /* padding-left: 14px !important */
      padding-left: 0 !important;
    padding-right: 0 !important;
    }
    /* 控制行高 */
    .el-table--medium td {
        padding: 3px 0 !important;
    }
    /* 控制行高 */
   .el-table--medium th {
        padding: 6px 0 !important;
    }

    /* 隔行变色 */
    .el-table--striped .el-table__body tr.el-table__row--striped td {
        background: #eff5fd !important;
    }
    /* 上移变色 */
    .el-table--enable-row-hover .el-table__body tr:hover>td {
       background-color: #ecf5ff !important;
    }
    /* 选中变色 */
    .el-table--striped .el-table__body tr.el-table__row--striped.current-row td {
         background-color: #eaedf1 !important;
    }
    /* 选中变色 */
    .el-table__body tr.current-row>td {
        background-color:#eaedf1 !important;
    }
     /*列表表头背景色*/
    .el-table__header  th{
      background: #e1e1e1;
       font-size: 14px;
    font-family: "Microsoft YaHei","Verdana", "Tahoma", "Lucida Grande", "Hiragino Sans GB", sans-serif;
    color: #333;
    font-weight: normal;
    text-align: center !important;
    }

/*表格边框颜色*/
.el-table--border th, .el-table--border td {
  border-color: #ccc !important;
}

     /*列表表头排序*/
    /* .el-table .caret-wrapper {
      height:16px !important;
    } */
    .el-table .descending .sort-caret.descending {
       bottom: auto !important;
       top: 10px !important;
    }
    .el-table .sort-caret.descending {
        bottom: auto !important;
        top: 10px !important;
    }
    .el-table .sort-caret.ascending {
        top: auto !important;
        bottom: 10px !important;
    }
    .el-table .caret-wrapper
    {
      width:10px !important;
    }
    .el-table th.is-sortable>.cell>.el-tooltip>span{
        margin-left: 0px !important;
    }
.filter-container .el-button--medium {
   padding: 10px 10px 10px 6px !important;
}
.filter-container  .el-button [class*="el-icon-"]+span {
    margin-left: 0px;
}
 .filter-container .el-button+.el-button {
    margin-left: 4px;
}
  .el-main {
    padding-bottom: 10px;
  }
    /* .el-date-picker__time-header
  {
    display:none;
  } */

  .el-autocomplete-suggestion.my-autocomplete li {
    line-height: normal;
    padding-top: 7px;
    /* padding-bottom: 7px */
}

.el-autocomplete-suggestion.my-autocomplete li .name {
    text-overflow: ellipsis;
    overflow: hidden
}

.el-autocomplete-suggestion.my-autocomplete li .addr {
    font-size: 12px;
    color: #b4b4b4
}

.el-autocomplete-suggestion.my-autocomplete li .addrr {
    font-size: 12px;
    color: #b4b4b4;
    float: right;
}

.el-autocomplete-suggestion.my-autocomplete li .highlighted .addr {
    color: #ddd
}

</style>
